const allPermissions = () => {
  return ['dashboard.index',
    'to_quotes.index',
    'quoteds.index',
    'in_orders.index',
    'finisheds.index',
    'docs_reciveds.index',
    'revisions.index',
    'revisions.store',
    'project_details.index',
    'quotation_files.index',
    'scopes.index',
    'additionals.index',
    'payments.index',
    'shipments.index',
    'claims.index',
    'claims.store',
    'claims.update',
    'gallerys.index',
    'rfis.index',
    'rfis.update',
    'quotations.index',
    'views.reports',
    'customers.update',
    'customer_comments_quotation.store',
    'users.index',
    'users.store',
    'users.update']
}

export default allPermissions
